import { render, staticRenderFns } from "./TwemojiPicker.vue?vue&type=template&id=ce0a141a&"
import script from "./TwemojiPicker.vue?vue&type=script&lang=js&"
export * from "./TwemojiPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports